export default "__VITE_ASSET__2b7277e2__"